import React from 'react';
import { Image, Save } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { HeroBannerSection } from './HeroBannerSection';
import { ColorAndLogoSection } from './ColorAndLogoSection';
import { LayoutStyleSection } from './LayoutStyleSection';
import { BrandingPreview } from './BrandingPreview';

export const BrandingCard = ({
  brandingData, setBrandingData, tenant,
  heroFileRef, uploadingHero, onHeroImageUpload,
  logoFileRef, uploadingLogo, onLogoUpload,
  detectingColor, onDetectColor,
  savingBranding, onSaveBranding,
}) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Image className="w-5 h-5" />
        Banner do Portal Público
      </CardTitle>
      <CardDescription>
        Personalize o banner e mensagens exibidos no formulário de denúncia público
      </CardDescription>
    </CardHeader>
    <CardContent className="space-y-6">
      <HeroBannerSection
        brandingData={brandingData}
        setBrandingData={setBrandingData}
        heroFileRef={heroFileRef}
        uploadingHero={uploadingHero}
        onHeroImageUpload={onHeroImageUpload}
      />

      <Separator />

      <ColorAndLogoSection
        brandingData={brandingData}
        setBrandingData={setBrandingData}
        logoFileRef={logoFileRef}
        uploadingLogo={uploadingLogo}
        onLogoUpload={onLogoUpload}
        detectingColor={detectingColor}
        onDetectColor={onDetectColor}
      />

      <Separator />

      <LayoutStyleSection brandingData={brandingData} setBrandingData={setBrandingData} />

      <Separator />

      <BrandingPreview brandingData={brandingData} tenant={tenant} />

      <div className="flex justify-end">
        <Button onClick={onSaveBranding} disabled={savingBranding} data-testid="save-branding-btn">
          <Save className="w-4 h-4 mr-2" />
          {savingBranding ? 'A guardar...' : 'Guardar Branding'}
        </Button>
      </div>
    </CardContent>
  </Card>
);
